<template>
  <div class="mb-4">
    <div class="mb-3">
      <StoryboardInstruction
        @input="$emit('update:instruction', $event)"
        @regenerate="$emit('regenerate')"
        :value="instruction"
        :label="label"
        :outlined="outlined"
        :loading="loading"
        :rows="rows"
        :max-height="maxHeight"
        :status="generationStatus"
        :button-icon="nodeId ? 'mdi-refresh' : 'mdi-creation'"
      />
    </div>

    <div class="d-flex align-center">
      <div class="flex-grow-1 mr-2">
        <audio
          class="audio-player"
          ref="audioPlayer" 
          controls
        >
          <source
            v-if="fileSound && !loading"
            :src="fileSound"
            type="audio/mpeg"
          >
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import StoryboardInstruction from './StoryboardInstruction.vue'
import RenditionActions from '@/store/content/rendition/actions-types'
import { BgActionEventBus } from '@/bgActionEventBus'

export default {
  name: 'StoryboardSoundGenerate',

  components: {
    StoryboardInstruction
  },

  data() {
    return {
      fileSound: null
    }
  },

  props: {
    instruction: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    nodeId: {
      type: [Number, String],
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    maxHeight: {
      type: String,
      default: '80px'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    generationStatus: {
      type: String,
      default: ''
    },
  },

  mounted() {
    if (this.nodeId) {
      this.getFileSound(this.nodeId)
      this.listenForRendition()
    }
  },

  watch: {
    nodeId(newNodeId) {
      if (newNodeId) {
        this.getFileSound(newNodeId)
        this.listenForRendition()
      }
    }
  },

  methods: {
    ...mapActions('content/rendition', [
      RenditionActions.GET_PREVIEW,
    ]),

    handleNotification(message) {
      if (message.type == 'rendition_service' && message.status == 'done' && message.node_id == this.nodeId) {
        this.getFileSound(this.nodeId)
        BgActionEventBus.$off('bgAction', this.handleNotification)
      }
    },

    listenForRendition() {
      BgActionEventBus.$off('bgAction', this.handleNotification)
      BgActionEventBus.$on('bgAction', this.handleNotification)
    },

    async getFileSound(nodeId) {
      const result = await this[RenditionActions.GET_PREVIEW](nodeId)

      this.fileSound = result[0].url || null

      if (this.fileSound && this.$refs.audioPlayer) {
        this.$refs.audioPlayer.load()
      }
    },
  },

  beforeDestroy() {
    BgActionEventBus.$off('bgAction', this.handleNotification)
  },

  emits: ['update:instruction', 'regenerate', 'play']
}
</script>

<style scoped>
  .audio-player {
    width: 100%;
    height: 35px;
  }
</style>
